import React, { useState } from 'react'
import { HiOutlinePaperClip } from 'react-icons/hi'
import { FaTrash, FaPen, FaShare, FaUser } from 'react-icons/fa'
import vendorProfile from '../../img/vendor_profile.png'
import vendorCover from '../../img/vendor_cover.jfif'
import EditVendorModal from '../modals/EditModal';
import AddOrEditVendorProfile from './AddOrEditVendorProfile';
import ConfirmationModal from '../modals/ConfirmationModal';
import InformationModal from '../modals/InformationModal';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { imgURL } from '../../apis/axios';
import { GrDeploy } from 'react-icons/gr';
import { toast } from 'react-toastify';
import useAxiosPrivate from '../../apis/useAxiosPrivate';
import { BsCheck2Circle } from 'react-icons/bs';
import { ArrowSwapHorizontal, AttachSquare, Clock, Edit, KeySquare, TickCircle, Trash, User } from 'iconsax-reactjs'
import Tooltip from '../../utils/Tooltip'
import ResetModal from '../modals/ResetModal'
import ResetUserPassword from './ResetUserPassword'
const TOGGLE_PUBLISH_URL = "/vendors/toggle/working"

const VendorCard = ({ vendor, onDelete, onEdit }) => {
    const [resetModal, setShowResetModal] = useState({ user: null, status: false });
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showIdentityModal, setShowIdentityModal] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const { t, i18n } = useTranslation();
    const tCard = t("vendorCard")
    const tResetUserPasswordInfo = t("resetPasswordForm");
    const axiosPrivate = useAxiosPrivate()

    async function toggleVendorWorkingStatus(vendorId) {
        try {
            setLoading(true)
            const params = `/${vendorId}`;
            const statusChangedResponse = await axiosPrivate.get(TOGGLE_PUBLISH_URL + params,
                { headers: { 'Accept-Language': i18n.language, 'Content-Type': 'application/json' } }
            );
            console.log('statusChangedResponse: ', statusChangedResponse);

            setLoading(false)
            onEdit({ ...vendor, working: statusChangedResponse?.data?.data?.isPublished });
            toast.success(statusChangedResponse?.data?.data?.message);
        } catch (error) {
            setLoading(false)
            toast.error(error.response?.data?.message);
        }
    }

    const handleShare = () => {
        if (vendor.lat && vendor.lng) {
            const url = `https://www.google.com/maps/search/?api=1&query=${vendor.lat},${vendor.lng}`;
            navigator.clipboard.writeText(url).then(() => {
                toast.success(tCard["locationCopied"]);
            }).catch(() => {
                toast.error(tCard["copyFailed"]);
            });
        } else {
            toast.error(tCard["noLocationAvailable"]);
        }
    };

    return (
        <>
            <div key={vendor.vendorId} className='flex-col mb-16 shadow-3 p-5 w-full border space-y-2 rounded-xl'>
                <div className='flex justify-between items-center'>
                    <p className={`${vendor.working ? "bg-green-700" : "bg-red-700"} text-white text-sm rounded-lg px-2`}>
                        {vendor.working ? tCard["working"] : tCard["outOfService"]}
                    </p>
                    <button onClick={() => isLoading ? null : toggleVendorWorkingStatus(vendor.vendorId)}
                        className={`${vendor.working ? "bg-green-200" : "bg-red-200"} text-sm`} title={"Working Vendor"}>
                        <GrDeploy className='inline-block mx-2' />
                    </button>
                </div>
                {/* Cover image container with profile image overlay */}
                <div className='w-full h-48 relative'>
                    {vendor.coverImage
                        ? <img className="rounded-xl w-full h-full object-cover" src={`${imgURL}/${vendor.coverImage}`} alt="Cover" />
                        : <img className="rounded-xl w-full h-full object-cover" src={vendorCover} alt="Default Cover" />
                    }
                    {/* Profile image overlay */}
                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
                        {vendor.profileImage
                            ? <img className="rounded-full w-24 h-24 object-cover border-4 border-white" src={`${imgURL}/${vendor.profileImage}`} alt="Profile" />
                            : <img className="rounded-full w-24 h-24 object-cover border-4 border-white" src={vendorProfile} alt='Profile' />
                        }
                    </div>
                </div>
                {/* Spacer to account for overlapping profile image */}
                <div className="h-12"></div>
                {/* Buttons below the images */}
                <div className="flex flex-col gap-2 mt-4">
                    <div className="flex flex-wrap justify-start gap-4">
                        <Link className='flex justify-between items-center border border-gray-200 shadow-none text-sm text-center text-black px-2 py-1 rounded-[8px] w-[calc(50%-0.5rem)]' to={"products"} state={{ vendor }}>
                            <p>{tCard["viewProducts"]}</p>
                            {vendor.inactiveProductsCount === 0
                                ? <TickCircle
                                    title="All active products"
                                    className="text-green-500 text-xl ml-1"
                                    variant="Bulk"
                                />

                                : <span className='rounded-md bg-red-700 text-white px-1 text-sm ml-1'>{vendor.inactiveProductsCount}</span>
                            }
                        </Link>
                        <Link className='flex justify-between items-center border border-gray-200 shadow-none text-sm text-center text-black px-2 py-1 rounded-[8px] w-[calc(50%-0.5rem)]' to={"categories"} state={{ vendor }}>
                            <p>{tCard["viewCategories"]}</p>
                            {vendor.inactiveCategoriesCount === 0
                                ? <TickCircle
                                    title="All active categories"
                                    className="text-green-500 text-xl ml-1"
                                    variant="Bulk"
                                />
                                : <span className='rounded-md bg-red-700 text-white px-1 text-sm ml-1'>{vendor.inactiveCategoriesCount}</span>
                            }
                        </Link>
                    </div>
                    <div className="flex justify-between items-center gap-2">
                        <Tooltip text={`${tCard["shareLocationVendorBtn"]}`}>
                            <button className='p-2 shadow-none border-none hover:bg-transparent' onClick={handleShare}>
                                <ArrowSwapHorizontal className='text-slate-500 hover:text-primary' variant="Bulk" />
                            </button>
                        </Tooltip>

                        <Tooltip text={`${tCard["viewVendorDocumentsBtn"]}`}>
                            <button className='p-2 shadow-none border-none hover:bg-transparent' onClick={() => setShowIdentityModal(true)}>
                                <AttachSquare className="text-slate-500 hover:text-primary" variant="Bulk" />
                            </button>
                        </Tooltip>

                        <Tooltip text={`${tCard["editCurrentVendorBtn"]}`}>
                            <button className='p-2 shadow-none border-none hover:bg-transparent' onClick={() => { setShowEditModal(true) }}>
                                <Edit className='text-slate-500 hover:text-primary' variant="Bulk" />
                            </button>
                        </Tooltip>

                        <Tooltip text={`${tCard["deleteCurrentVendorBtn"]}`}>
                            <button className='p-2 shadow-none border-none hover:bg-transparent' onClick={() => setShowDeleteModal(true)}>
                                <Trash className="text-slate-500 hover:text-primary" variant="Bulk" />
                            </button>
                        </Tooltip>

                        <Tooltip text={tResetUserPasswordInfo.resetUserPasswordTitle}>
                            <KeySquare
                                size={26}
                                className="text-gray-400 cursor-pointer mx-1 hover:text-yellow-500 transition-colors duration-200 ease-in"
                                variant="Bulk"
                                onClick={() => setShowResetModal({ user: vendor, status: true })}
                            />
                        </Tooltip>

                        <Tooltip text={`${tCard["viewVendorUsersBtn"]}`}>
                            <Link className='p-2 shadow-none border-none hover:bg-transparent' to={"users"} state={{ vendor }}>
                                <User
                                    className='text-slate-500 hover:text-primary'
                                    variant="Bulk"
                                />
                            </Link>
                        </Tooltip>
                    </div>
                </div>
                <div className="flex flex-col gap-y-4 text-black">
                    <div className="flex justify-between">
                        <h3 className='text-black flex items-center'>
                            {i18n.language === "en" ? vendor.fullName : vendor.arFullName}
                            {/* {vendor.fullName} */}
                            <sub className="lowercase mx-2 bg-slate-800 text-white text-xs rounded-lg px-2 py-1">
                                {vendor.region?.replace("_", " ")}
                            </sub>
                        </h3>
                        <h3 className='capitalize'>{vendor.vendorType}</h3>
                    </div>
                    <div className="text-sm flex justify-between">
                        <p>{tCard["maxDeliveQuestion"]}</p>
                        <strong className='text-white px-1 bg-slate-400 rounded-lg'>
                            {vendor.maxKilometerDelivery ? vendor.maxKilometerDelivery + tCard["kmUnit"]
                                : tCard["notProvided"]}</strong>
                    </div>
                    <div className="text-sm flex justify-between">
                        <p>{tCard["minChargeQuestion"]}</p>
                        <strong className='text-white px-1 bg-slate-400 rounded-lg'>
                            {vendor.minChargeLongDistance ? vendor.minChargeLongDistance + tCard["aedUnit"]
                                : tCard["notProvided"]}</strong>
                    </div>
                    <hr />
                    <div className="text-sm flex justify-between font-normal mt-4">
                        <p className='text-green-600 capitalize text-[13px] flex items-center gap-1'>
                            <Clock
                                className='text-green-500'
                                variant="Bulk"
                            /> {tCard["openingTxt"]} {vendor.fOpeningTime}</p>
                        {vendor.stillOpening
                            ? <p className="bg-green-200 shadow-none px-2 rounded">{tCard["openedTxt"]}</p>
                            : <p className="bg-red-200 shadow-none px-2 rounded">{tCard["closedTxt"]}</p>}
                        <p className='text-red-600 capitalize text-[13px] flex items-center gap-1'>
                            <Clock
                                className='text-red-500'
                                variant="Bulk"
                            />
                            {tCard["closingTxt"]} {vendor.fClosingTime}</p>
                    </div>
                </div>
            </div>
            <EditVendorModal showModal={showEditModal} setShowModal={setShowEditModal} target="Vendor">
                <AddOrEditVendorProfile key={vendor.vendorId}
                    isEdit={true}
                    onEdit={onEdit}
                    currentVendor={vendor} />
            </EditVendorModal>
            <ResetModal showModal={resetModal.status} setShowModal={setShowResetModal} target={tResetUserPasswordInfo["resetUserPasswordTitle"]}>
                <ResetUserPassword
                    key={vendor?.vendorId}
                    isEdit={true}
                    currentUser={vendor}
                    setShowResetModal={setShowResetModal}
                />
            </ResetModal>
            <ConfirmationModal
                title={"Confirm Vendor Delete"}
                btnColor={"bg-danger"}
                message={"Are you sure for deleting this vendor?"}
                onAction={() => { onDelete(vendor.vendorId); setShowDeleteModal(false) }}
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal} />
            <InformationModal
                title={"License and Identity Images"}
                btnColor={"bg-info"}
                showModal={showIdentityModal}
                setShowModal={setShowIdentityModal}>
                <div className='flex justify-between'>
                    <img className='w-[45%] h-72 rounded-xl' src={`${imgURL}/${vendor.licenseImage}`} alt="license" />
                    <img className='w-[45%] h-72 rounded-xl' src={`${imgURL}/${vendor.identityImage}`} alt="identity" />
                </div>
            </InformationModal>
        </>
    )
}

export default VendorCard